<mat-card>
  <mat-tab-group mat-stretch-tabs>
    <mat-tab label="Code of Conduct">
      <app-players-completed name="Code of Conduct"> </app-players-completed>
    </mat-tab>
    <mat-tab label="Insider Trading">
      <app-players-completed name="Insider Trading"> </app-players-completed>
    </mat-tab>
    <mat-tab label="IT Security">
      <app-players-completed name="IT Security"> </app-players-completed>
    </mat-tab>
    <mat-tab label="Posh">
      <app-players-completed name="Posh"> </app-players-completed>
    </mat-tab>
    <mat-tab label="Health and Safety">
      <app-players-completed name="Health and Safety"> </app-players-completed>
    </mat-tab>
  </mat-tab-group>
</mat-card>
